import anime from 'animejs'

export default function scrollTo($target = document.body, offset = 0, duration) {
  const targetOffsetTop = $target.getBoundingClientRect().top;
  const whereToScroll = ((document.documentElement.scrollTop || document.body.scrollTop) + targetOffsetTop) - offset;
  anime({
    targets: [ document.documentElement, document.body ],
    scrollTop: whereToScroll,
    duration: duration || (Math.abs(document.documentElement.scrollTop || document.body.scrollTop) - whereToScroll * 1000 / window.innerHeight),
    easing: 'easeOutQuart',
  })
}



// WEBPACK FOOTER //
// ./src/scripts/utils/scroll-to.js